<div class="navi-menu" data-testid="nav-menu-container">
    <button class="ev-button primary" (click)="startNavigation()"
        [ngClass]="{ 'grayscale': failedPlan || noRoute || loadingMap }" name="go_btn" data-testid="nav-menu-go-btn">
        {{ languageService.languageJSON.NavigationMenu_Go }}
    </button>

    <button class="ev-button" (click)="backToRange()" name="stop_btn" data-testid="nav-menu-cancel-btn">
        {{ languageService.languageJSON.Global_Cancel }}
    </button>
</div>